import { useEffect, useState, type FormEvent } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { api } from '../api/client';
import { Card } from '../components/ui';

export function RegisterPage() {
  const { user, loading, register } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [requireInvite, setRequireInvite] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get<{ requireInvite: boolean }>('/api/auth/config')
      .then((c) => setRequireInvite(c.requireInvite))
      .catch(() => setRequireInvite(false));
  }, []);

  if (!loading && user) return <Navigate to="/dashboard" replace />;

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await register(email, password, inviteCode || undefined);
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Registration failed');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Card style={{ maxWidth: 400, margin: '2rem auto' }}>
      <h2 style={{ fontSize: '1.25rem', fontWeight: 600, marginTop: 0, marginBottom: '1.5rem' }}>Create account</h2>

      {error && <div className="alert-error" style={{ marginBottom: '1rem' }}>{error}</div>}

      <form onSubmit={onSubmit}>
        <div style={{ marginBottom: '1rem' }}>
          <label className="form-label" htmlFor="email">Email</label>
          <input
            id="email" className="form-input" type="email" required autoComplete="email"
            value={email} onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div style={{ marginBottom: '1rem' }}>
          <label className="form-label" htmlFor="new-password">Password</label>
          <input
            id="new-password" className="form-input" type="password" required autoComplete="new-password" minLength={8}
            value={password} onChange={(e) => setPassword(e.target.value)}
          />
        </div>
        {requireInvite && (
          <div style={{ marginBottom: '1rem' }}>
            <label className="form-label" htmlFor="invite">Invite code</label>
            <input
              id="invite" className="form-input" type="text" required
              value={inviteCode} onChange={(e) => setInviteCode(e.target.value)}
            />
          </div>
        )}
        <button type="submit" className="btn-primary" style={{ width: '100%', marginTop: '0.5rem' }} disabled={busy}>
          {busy ? 'Creating…' : 'Create account'}
        </button>
      </form>

      <p className="muted" style={{ marginTop: '1rem', fontSize: '0.875rem', textAlign: 'center' }}>
        Already have an account? <Link to="/login">Sign in</Link>
      </p>
    </Card>
  );
}
